'use strict';
import { SideMenuBase } from './SideMenuBase';
import Render from './SideMenuRender';
import { connect } from 'react-redux';

class SideMenu extends SideMenuBase {
    render() {
        return Render.call(this, this.props, this.state);
    }
}

export default SideMenu = connect((state)=>{
    return {user:state.user || {},
    socket: state.socket || "",}
})(SideMenu);